import { ReviewRepository } from "../../repositories/ReviewRepository";

/**
 * Reject Review Use Case
 * Rejects a review request
 */
export class RejectReviewUseCase {
  constructor(private repository: ReviewRepository) {}

  async execute(id: number, comments: string): Promise<void> {
    if (!id || id <= 0) {
      throw new Error("Invalid review ID");
    }

    if (!comments || comments.trim() === "") {
      throw new Error("Comments are required when rejecting a review");
    }

    return await this.repository.rejectReview(id, comments);
  }
}
